<template>
  <el-dialog title="购票记录" :visible.sync="dialogFormVisible" width="900px">
    <Table :data="list" :columns="columns" :loading="listLoading">
      <template v-slot:scenery_name>
        <el-table-column label="景区名称" width="120">
          <template slot-scope="scope"> {{ scope.row.tc_ticket_info.scenery_name }} </template>
        </el-table-column>
      </template>
      <template v-slot:ticket_name>
        <el-table-column label="票型" width="100" align="center">
          <template slot-scope="scope"> {{ scope.row.tc_ticket_info.ticket_name }} </template>
        </el-table-column>
      </template>
      <template v-slot:ticket_id>
        <el-table-column label="票型ID" width="120" align="center">
          <template slot-scope="scope"> {{ scope.row.tc_ticket_info.ticket_id }} </template>
        </el-table-column>
      </template>
      <template v-slot:book_man>
        <el-table-column label="预定人" width="100" align="center">
          <template slot-scope="scope">
            {{ scope.row.book_man.name }} <br />
            {{ scope.row.book_man.mobile }}</template
          >
        </el-table-column>
      </template>
      <template v-slot:status>
        <el-table-column label="订单状态" width="100" align="center">
          <template slot-scope="scope">
            {{
              ['', '已支付', '同程已确认', '退款待确认', '已退款', '', '退款失败'][scope.row.status]
            }}
          </template>
        </el-table-column>
      </template>
      <template v-slot:ticket_code_address>
        <el-table-column label="操作" minWidth="100" align="center" fixed="right">
          <template slot-scope="scope">
            <p @click="handleLookCode(scope.row)" style="cursor: pointer; color: #409eff">
              点击查看
            </p>
          </template>
        </el-table-column>
      </template>
    </Table>
    <div slot="footer" class="dialog-footer">
      <!-- <el-button type="primary" @click="handleSendMsg">重发短信</el-button> -->
      <el-button type="primary" @click="handleRefund" v-if="status != 3 && status != 4"
        >退款</el-button
      >
    </div>
  </el-dialog>
</template>

<script>
import { getTicketRecord, sendMsg, postRefund, refundTickets } from '@/api/orders'

export default {
  name: 'Record',
  data() {
    return {
      list: null,
      listLoading: true,
      columns: [
        {
          label: '订单号',
          width: '200',
          prop: 'tc_serial_no',
          showOverflowTooltip: true
        },
        {
          label: '景区名称',
          slot: 'scenery_name'
        },
        {
          label: '票型',
          slot: 'ticket_name'
        },
        {
          label: '票型ID',
          slot: 'ticket_id'
        },
        {
          label: '单价',
          width: '100',
          prop: 'ticket_unit_price',
          align: 'center'
        },
        {
          label: '预定日期',
          width: '90',
          prop: 'travel_date',
          align: 'center'
        },
        {
          label: '预定人',
          slot: 'book_man'
        },
        {
          label: '身份证号码',
          slot: 'card_no_list'
        },
        {
          label: '预定数量',
          width: '80',
          prop: 'ticket_num',
          align: 'center'
        },
        {
          label: '订单状态',
          slot: 'status'
        },
        {
          label: '下单时间',
          width: '160',
          prop: 'add_time',
          align: 'center'
        },
        {
          label: '入园辅助码',
          slot: 'ticket_code_address'
        }
      ],
      dialogFormVisible: false,
      buy_record_id: '',
      status: 0,
      sn: ''
    }
  },
  methods: {
    /**
     * @description: 详情
     * @param {*} sn
     * @return {*}
     */
    handleRecord(sn) {
      this.sn = sn
      getTicketRecord(sn).then((res) => {
        this.list = res.data
        this.buy_record_id = res.data.buy_record_id
        this.status = res.data.status
        this.dialogFormVisible = true
        this.listLoading = false
      })
    },
    handleLookCode(row) {
      window.open(row.ticket_code_address, '_blank')
    },
    /**
     * @description: 重发短信
     * @return {*}
     */
    handleSendMsg() {
      const _this = this
      this.$confirm('确认重新发送短信么？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          sendMsg(_this.buy_record_id).then(() => {
            _this.$notify({
              title: '成功',
              message: '发送成功',
              type: 'success'
            })
          })
        })
        .catch(() => {})
    },
    /**
     * @description: 退款
     * @return {*}
     */
    handleRefund() {
      const _this = this
      this.$confirm('确认发起购票退款么？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          refundTickets(_this.sn).then(() => {
            this.$parent.$notify({
              title: '成功',
              message: '退款发起成功',
              type: 'success'
            })
            this.$parent.fetchData()
            this.dialogFormVisible = false
          })
        })
        .catch(() => {})
    }
  }
}
</script>
<style scoped lang="less">
.sn {
  margin-bottom: 10px;
}
.dialog-footer {
  display: flex;
  justify-content: flex-end;
  .el-button {
    width: 100px;
    letter-spacing: 2px;
    font-weight: 600;
  }
}
</style>
